import { Card } from "@/components/ui/card";
import { gainClass } from "@/lib/format";

export function StatCard({ label, value, sub, delta, deltaPct, testId, accent = false, compact = false, onClick, valueClass = "" }) {
    const showDelta = deltaPct != null && deltaPct !== "" && deltaPct !== "—";
    const clickable = !!onClick;
    return (
        <Card
            onClick={onClick}
            className={`p-4 relative overflow-hidden shadow-[inset_0_1px_0_0_rgba(255,255,255,0.04)] ${accent ? "ring-1 ring-primary/20" : ""} ${clickable ? "cursor-pointer hover:border-primary/50 hover:-translate-y-0.5 transition-all duration-200" : ""}`}
            data-testid={testId}>
            <div className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground truncate">{label}</div>
            <div className="mt-1.5 flex items-baseline gap-2 flex-wrap">
                <span className={`num font-bold tracking-tight text-base md:text-lg ${valueClass}`}
                    data-testid={testId ? `${testId}-value` : undefined}>{value}</span>
                {showDelta && (
                    <span className={`num font-semibold text-xs md:text-sm ${gainClass(delta)}`}
                        data-testid={testId ? `${testId}-delta` : undefined}>{deltaPct}</span>
                )}
            </div>
            {sub && <div className="mt-1 text-xs text-muted-foreground num truncate">{sub}</div>}
        </Card>
    );
}
